import { Component, Prop, Vue } from "vue-property-decorator";
import { Dropdown, Menu, Icon } from "ant-design-vue";
import { fmtMsg, ActionItem, Action } from "commonui";
import { CommonLocale } from "@/locales/localeid";
import { getModule } from "vuex-module-decorators";
import TitleListState from "@/modules/title-list";
import { LanguageSkill } from "@/util/enum";

enum ContentExposureActionEnum {
	Edit,
	Duplicate,
	Remove,
	Save,
	Cancel,
	ManageOrder
}

export interface ContentExposureActionProps {
	isEdit?: boolean;
	disabled?: boolean;
	onEditing?: (isEdit: boolean) => Promise<void>;
	onDuplicating?: () => void;
	onRemoving?: () => void;
	onSaving?: () => void;
}

@Component({
	components: {
		Dropdown,
		Menu,
		MenuItem: Menu.Item,
		Icon,
		Action,
		ActionItem
	}
})
export default class ContentExposureAction extends Vue {
	@Prop({ default: false }) isEdit!: boolean;
	@Prop({ default: false }) disabled!: boolean;
	@Prop({ default: () => {} }) onEditing!: (isEdit: boolean) => Promise<void>;
	@Prop({ default: () => {} }) onDuplicating!: () => void;
	@Prop({ default: () => {} }) onRemoving!: () => void;
	@Prop({ default: () => {} }) onSaving!: () => void;
	@Prop({ default: () => {} }) onManageOrder!: () => void;
	public titleListModule = getModule(TitleListState);

	get contentExposureActionEnum() {
		return ContentExposureActionEnum;
	}
	get commonLocale(): any {
		return CommonLocale;
	}
	onActionChange(e) {
		switch (e.key) {
			case ContentExposureActionEnum.Edit:
				this.onEditing(true);
				break;
			case ContentExposureActionEnum.Duplicate:
				this.onDuplicating();
				break;
			case ContentExposureActionEnum.Remove:
				this.onRemoving();
				break;
			case ContentExposureActionEnum.Save:
				this.onSaving();
				break;
			case ContentExposureActionEnum.Cancel:
				this.onEditing(false);
				break;
			case ContentExposureActionEnum.ManageOrder:
				this.onManageOrder();
				break;
			default:
				break;
		}
	}
	formatMessage(id: string, params?: any): string {
		return fmtMsg(id, params);
	}

	get isReader() {
		return this.titleListModule.editedContentDetails.languageSkillId === LanguageSkill.Read;
	}
}
